// Final steps section form field enum
export enum FinalStepsFormField {
  FINAL_STEPS_INTERNAL_NOTES = 'finalStepsInternalNotes'
}
